import { StylesConfig } from 'react-select';

// The menu renders inside the popout, so picking a project is not a click outside it
export const inlineProjectSelectStyles: StylesConfig = {
    control: (base) => ({
        ...base,
        fontSize: '0.75rem',
    }),
    menu: (base) => ({
        ...base,
        position: 'static',
        width: '100%',
        minWidth: 0,
        marginBottom: 0,
        boxShadow: 'none',
        border: 'none',
        borderRadius: 0,
    }),
    option: (base) => ({
        ...base,
        fontSize: '0.75rem',
        '& > div > :first-child': {
            width: '1.75rem',
            height: '1.75rem',
            flexShrink: 0,
        },
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '13rem',
    }),
};
